import { render, staticRenderFns } from "./HomeUpperSection.vue?vue&type=template&id=89984608&scoped=true"
import script from "./HomeUpperSection.vue?vue&type=script&lang=ts"
export * from "./HomeUpperSection.vue?vue&type=script&lang=ts"
import style0 from "./HomeUpperSection.vue?vue&type=style&index=0&id=89984608&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89984608",
  null
  
)

export default component.exports